import DatePickerCalendar from "../../dashboard/calendars/DatePickerCalendar";
import ReactTooltip from "react-tooltip";
import Constants from "../../../Constants";
import Select from "react-select";
import {
  dateConvertToTimeStamp,
  dateFormat,
  TIME_LIST,
  transformBlankToNull,
  utcDateTimeWithTimeZone,
  dateDifference,
  utcDateTimeWithTimeZoneWithFormat,
} from "../../../services/Util";
import React, { useEffect, useRef, useState } from "react";
import APIUrls from "../../../services/APIUrls";
import {
  getAxiosResponse,
  putAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import $ from "jquery";

export default function RequestTranslationAgainVendor(prop) {
  const [toggleIntialCal, toggleIntialCalFlag] = useState(false);
  const [customerBootstrapData, setCustomerBootstrapData] = useState(false);
  const [deliveryDueDate, setDeliveryDueDate] = useState("");
  const [deliveryDueTime, setDeliveryDueTime] = useState(-1);
  const [dataLoaded,setDataLoaded] = useState(false)
  const [allPreferredVendors, setAllPreferredVendors] = useState([]);
  const [selectedPreferedVendors, setSelectedPreferedVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState({});
  const refToggle2 = useRef(null);
  const refCalendar2 = useRef(null);
  const requestTranslationTooltipRef = useRef(null);

  const projectResource = prop?.projectDetails?.resource?.projectResource;

  const getInternalTranslatorVendor = async (depId) => {
    const dateTimestamp = dateConvertToTimeStamp();
    const result = await getAxiosResponse(
      APIUrls.TRANSALATION_VENDORS(depId) + `?_=${dateTimestamp}`
    );
    if (result?.data?.data) {
      setAllPreferredVendors(result?.data?.data);
      
    }
    setDataLoaded(true)
    getAxiosResponse(APIUrls.BID_REQUEST_BY_ID(projectResource.id)).then(
      (res) => {
        setSelectedPreferedVendors(res.data.data.preferredVendors);
      }
    );
  };

  useEffect(() => {
    if (allPreferredVendors.length > 0 && selectedPreferedVendors.length > 0) {
      var filtered = allPreferredVendors.filter((follower) =>
        selectedPreferedVendors.some(
          (addedFollower) => addedFollower.id === follower.vendor.id
        )
      );
      setSelectedVendor(filtered[0].vendor);
    }
  }, [selectedPreferedVendors, allPreferredVendors]);
  const checkSelectedVendor = (id) => {
    if (selectedVendor && selectedVendor.id === id) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then((res) => {
      setCustomerBootstrapData(res.data.data);
    });
  }, []);

  useEffect(() => {
    setDataLoaded(false)
    getInternalTranslatorVendor(projectResource?.userGroup?.id);
  }, [projectResource]);

  const hideModel = () => {
    document.body.classList.remove("modal-open-7");
    $('.focusAdd').trigger('focus');
    $('.focusAdd').removeClass('focusAdd');
    prop.popupState(false);
  };

  const handleFocusOnPopup = event => {
    if(event.key === Constants.ESCAPE && $('.small-dropdown-select input').attr('aria-expanded')==='false'){
      hideModel();
    }
  }
    $('.close').on("keydown", function (e) {
      if (e.key === Constants.TAB && !e.shiftKey) {
        e.preventDefault();
        $('#requestTranslationTooltipRef').trigger('focus');
      }
    });
    $('#requestTranslationTooltipRef').on("keydown", function (e) {
      if (e.key === Constants.TAB && e.shiftKey) {
        e.preventDefault();
        $('.close').trigger('focus');
      }
    });
  const showCalendarDeliveryDate = () => {
    toggleIntialCal ? toggleIntialCalFlag(false) : toggleIntialCalFlag(true);
  };

  const setDeliveryDate = (event) => {
    setDeliveryDueDate(event);
    toggleIntialCalFlag(false);
  };

  const setTime = (event) => {
    let currentDeliveryDueDate =
      deliveryDueDate !== ""
        ? new Date(deliveryDueDate)
        : new Date(projectResource?.deliveryDueDate);
    currentDeliveryDueDate.setHours(event.value);
    setDeliveryDueDate(currentDeliveryDueDate);
    setDeliveryDueTime(event.value);
  };

  const assigneeUser = (data) => {
    setSelectedVendor(data.vendor);
  };

  const saveNewTranslationRequest = () => {
    let newProjectResource = structuredClone(projectResource);
    if(deliveryDueDate !== ''){
        var diff = dateDifference(
            new Date(`${deliveryDueDate}`),
            new Date(projectResource?.deliveryDueDate),
            "days"
          );
          if(diff !== 0){
            newProjectResource.deliveryDueDateChanged=true
            newProjectResource.deliveryDueDate = deliveryDueDate
            newProjectResource.deliveryDueDateHour = deliveryDueTime;
          }
    }else{
        newProjectResource.deliveryDueDateChanged=false
    }
    
    newProjectResource.isExternalBidless = true;
    newProjectResource.isInternalTranslator = false;
    newProjectResource.isMachineTranslation = false;
    newProjectResource.preferredVendors = [
      {
        id: selectedVendor.id,
        name: selectedVendor.id,
      },
    ];
    newProjectResource.biddingEnabled = false;
    newProjectResource.bidDueDateEditable = false;
    newProjectResource.bidDueDateHour = null;
    newProjectResource.bidDueDateId = "ProjectDatesViewbidDueDate";
    newProjectResource.status = "waiting_for_vendor_acceptance";
    var payload = transformBlankToNull(newProjectResource);
    putAxiosResponse(APIUrls.PROJECT(projectResource?.id), payload).then(
      (res) => {
        hideModel();
        prop.refresh();
      }
    );
  };

  return (
    <div id="modal-open-7" className="lightbox-panel" aria-labelledby="requestTranslationAgainVendor" aria-modal="true" role="dialog">
      <div className="inner-lightbox-panel pb-0" onKeyDown={(e)=>handleFocusOnPopup(e)}>
        <div className="modal-header flex padd-lr">
          <h5 id="requestTranslationAgainVendor">Request Translation Again</h5>
        </div>
        <div className="lightbox-content padd-22 vender-form-block">
          <p>
            The vendor has rejected your request. You can choose to request
            translation again from the same or a different vendor.
          </p>
          <div className="flex wrap-dropdown wrap-group-dropdown">
            <div className="global-dropdown-block flex-center">
              <div className="tooltip-container">
                <strong>I need initial translation by</strong>
                <p
                  tabIndex={0}
                  data-events={["focus"]}
                  data-eventsoff={["blur"]}
                  data-padding="10px 10px 10px 10px"
                  data-place="right"
                  data-tip={Constants.TRANSLATION_SUBMISSION_TOOLTIP}
                  data-for="translation-submission-tooltip"
                  id="requestTranslationTooltipRef"
                  aria-label="Tooltip"
                >
                  <svg
                    className="svg-tooltip-icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                  </svg>
                  <div class="font-zero">{Constants.TRANSLATION_SUBMISSION_TOOLTIP}</div>
                </p>
                <ReactTooltip
                  className="tooltip"
                  id="translation-submission-tooltip"
                  role="tooltip"
                  ref={requestTranslationTooltipRef}
                ></ReactTooltip>
              </div>
              <div className="flex-center w-d100">
                <div
                  className="global-dropdown-select"
                  aria-label="I need initial translation by"
                >
                  <button
                    onClick={(e) => {
                      showCalendarDeliveryDate(e);
                    }}
                    ref={refToggle2}
                    tabIndex={0}
                    type="button"
                    className="drop-down-btn gb-dropBtn"
                  >
                    <span>
                      {deliveryDueDate !== ""
                        ? dateFormat(deliveryDueDate, Constants.DATE_IN_WORDS)
                        : projectResource?.deliveryDueDate
                        ? dateFormat(
                            projectResource?.deliveryDueDate,
                            Constants.DATE_IN_WORDS
                          )
                        : "Day, Month, Year"}
                    </span>
                    <svg
                      className="calender-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                        fill="#3564EB"
                      />
                    </svg>
                  </button>
                </div>
                {toggleIntialCal ? (
                  <div ref={refCalendar2}>
                    <DatePickerCalendar
                        value={
                          deliveryDueDate !== ""
                            ? new Date(deliveryDueDate)
                            : new Date(projectResource?.deliveryDueDate)
                        }
                        minDate={new Date()}
                        className="dashCalendarDeadLine"
                        selectDate={setDeliveryDate}
                    />
                  </div>
                ) : (
                  ""
                )}
                <div className="global-dropdown-select small-dropdown-select">
                  <Select
                    className=""
                    classNamePrefix="cw"
                    value={TIME_LIST.filter(function (option) {
                      return (
                        option?.value ==
                        (deliveryDueTime === -1
                          ? dateFormat(projectResource?.deliveryDueDate, "h")
                          : deliveryDueTime)
                      );
                    })}
                    aria-label="What Time?"
                    onChange={(event) => setTime(event)}
                    options={TIME_LIST}
                    menuShouldScrollIntoView={false}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mar-bot6" id="selectPreferedVendor">
            <strong>Select your preferred vendor </strong> (click on a vendor to
            select or deselect)
          </div>
            <div>
              {allPreferredVendors && allPreferredVendors.length > 0 ? (
                <div className="translate-box flex" role="radiogroup" aria-labelledby="selectPreferedVendor">
                  {allPreferredVendors.map((res, index) => (
                    <div key={index} className="translate-box-list">
                      <a
                        tabIndex="0"
                        onClick={() => assigneeUser(res)}
                        className={
                          checkSelectedVendor(res.vendor.id) ? " vendor" : ""
                        }
                        // aria-label="tab"
                        aria-checked={checkSelectedVendor(res.vendor.id) ? 'true' : 'false'}
                        role="radio"
                      >
                        <span>{res.vendor.name}</span>
                      </a>
                    </div>
                  ))}
                </div>
              ) : 
              dataLoaded ? (
                <p className="error">
                  No preferred vendor has been configured for your account for
                  accepting bidless translation requests. Contact your account
                  administrator to configure your preferred vendors to accept
                  bidless translation quotes.
                </p>
              ) : ''}
            </div>
        </div>
        <div className="modal-footer modal-footer-border flex px-22">
          <button
            className="btn btn-bold active"
            onClick={saveNewTranslationRequest}
          >
            OK
          </button>
          <button className="btn btn-bold set-right close" onClick={hideModel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
